import { Component, Inject } from "@angular/core"
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: 'token-expiration-dialog',
  templateUrl: './token-expiration-dialog.component.html',
  styleUrls: ['./token-expiration-dialog.component.scss'],
})
export class TokenExpirationDialogComponent {
  type: string;
  titleStr: string;
  bodyMsg: string;
  head1: string = $localize`:Logout Dialog Confirmation |Title text displayed in Confirmation box of logout@appDialogLogout:Are you sure you wish to logout?`;
  head2: string = $localize`:Session Expired Dialog header |Title text displayed for session expierd dialog@appDialogSessionExpired:Your session has expired`;
  bodyText1: string = $localize`:Logout Dialog text | dialog text displayed in logout confirmation @appDialogLogoutText:Once you log out, all your work will be saved. Please click the button below to return to the login screen.`;
  bodyText2: string = $localize`:Session Expiry Dialog Text |Dialog text displayed in session expiry dialog window@appDialogSessionExpiryText:For security reasons, we require that you log into our system again. All of your work has been saved. Please click the button below to return to the login screen.`;
  hideCloseButton:boolean =false;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private _dialogRef: MatDialogRef<TokenExpirationDialogComponent>) {
    this.type = data.source;
    
    if(this.type == 'logout'){
      this.titleStr = this.head1;
      this.bodyMsg = this.bodyText1;
    }else{
      this.hideCloseButton = true;
      this.titleStr = this.head2;
      this.bodyMsg = this.bodyText2;
    }
  }
  
  /**
   * Close the dialog
   */
  logout(): void {
    this._dialogRef.close({event: 'logout'});
  }

  cancel():  void {
    this._dialogRef.close({event: 'cancel'});
  }
}
